import type { HostFulfillmentKind } from "../ops/hostOrderFulfillment.js";

export type InstanceFulfillmentKind = HostFulfillmentKind;

export const INSTANCE_FULFILLMENT_KINDS: ReadonlyArray<InstanceFulfillmentKind> = [
  "inventory",
  "custom",
];

export function parseInstanceFulfillment(
  raw: unknown,
): InstanceFulfillmentKind | null | undefined {
  if (raw === undefined) return undefined;
  if (raw === null || raw === "") return null;
  if (raw === "inventory" || raw === "custom") return raw;
  return undefined;
}

/** Fulfillment can flip until the opportunity is closed. */
export function opportunityFulfillmentIsLocked(status: string): boolean {
  return status === "complete" || status === "lost";
}

export type FulfillmentPatchPlan = {
  fulfillment: InstanceFulfillmentKind | null;
  mfg_unit_id: string | null;
  lookupSerial: string | null;
};

/**
 * Inventory can attach a lot unit. Custom / unset always detaches.
 * Does not touch `mfg_units.ops_deal_id`.
 */
export function planOpportunityFulfillmentPatch(args: {
  currentFulfillment: InstanceFulfillmentKind | null;
  currentUnitId: string | null;
  requestedFulfillment?: InstanceFulfillmentKind | null;
  serialInBody: boolean;
  requestedSerial: string | null;
}): FulfillmentPatchPlan {
  let fulfillment = args.currentFulfillment;
  let unitId = args.currentUnitId;
  let lookupSerial: string | null = null;

  if (args.serialInBody) {
    const serial = args.requestedSerial?.trim() || "";
    if (!serial) {
      unitId = null;
    } else {
      lookupSerial = serial;
      fulfillment = "inventory";
    }
  }

  if (args.requestedFulfillment !== undefined) {
    fulfillment = args.requestedFulfillment;
  }

  if (fulfillment !== "inventory") {
    unitId = null;
    lookupSerial = null;
  }

  return { fulfillment, mfg_unit_id: unitId, lookupSerial };
}
